import types from '@/vuex/arquivos-assinados/mutations-types'

const mutations = {
  [types.SET_LISTA_ARQUIVOS_ASSINADOS]: (state, payload) => {
    state.listaArquivosAssinados = payload.listaArquivosAssinados
  },
  [types.SET_ARQUIVO_ASSINADO_BLOB_URL]: (state, payload) => {
    state.arquivoAssinadoBlobURL = payload.arquivoAssinadoBlobURL
  },
  [types.SET_LISTA_TIPOS_ASSINATURA]: (state, payload) => {
    state.listaTiposAssinatura = payload.listaTiposAssinatura
  },
  [types.SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG]: (state) => {
    state.arquivoAssinadoInsercaoDialog = true
  },
  [types.HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG]: (state) => {
    state.arquivoAssinadoInsercaoDialog = false
  }
}
export default mutations
